import React, { useContext, useMemo } from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import {
  Order,
  ChatHistoryManagerContext,
  ChatOnList,
} from '~/service/ChatHistoryManager'
import { FormattedMessage } from '~/translations/utils'
import trans from '~/translations/trans'
import useResizeObserver from 'use-resize-observer'
import Scrollbar from 'react-scrollbars-custom'
import DateTooltip from '~/components/common/DateTooltip'
import MainContent from '../MainContent'
import Tooltip from '~/components/common/Tooltip'

const HistoryList: React.FC = ({}) => {
  const {
    chats,
    filter,
    setFilter,
    loadHook,
    loadMore,
    loading,
    search,
    setSearch,
    order,
    setOrder,
  } = useContext(ChatHistoryManagerContext)

  const { ref, width = 0 } = useResizeObserver<HTMLElement>()

  loadHook()

  const sort = (name: Order) => {
    setOrder(name)
    setFilter({
      ...filter,
      order: name,
    })
  }

  return (
    <>
      <div className="chat-list chat-history-list">
        <div className="list-table-header chat-history-list-table-header">
          <div className="chat-history-list-table-header-name"></div>
          <a
            className={classNames('chat-history-list-table-header-created', {
              active: order.includes('created'),
            })}
            onClick={e => {
              e.preventDefault()
              order == 'createdDesc' ? sort('createdAsc') : sort('createdDesc')
            }}
          >
            <FormattedMessage id="chat / history / list / header / created" />
            {order.includes('created') && (
              <span
                className={classNames(
                  'fa client-list-table-header-arrow',
                  { 'fa-caret-up': order == 'createdAsc' },
                  { 'fa-caret-down': order == 'createdDesc' }
                )}
              />
            )}
          </a>
        </div>
        <MainContent onScrolledToEnd={() => loadMore()}>
          {chats.map(chat => (
            <ListItem chat={chat} key={chat.id} />
          ))}
        </MainContent>
      </div>
    </>
  )
}

type ListItemProps = {
  chat: ChatOnList
}

const ListItem: React.FC<ListItemProps> = ({ chat }) => {
  return (
    <>
      <Link
        to={'/chat/history/' + chat.id}
        className={classNames('chat-list-item', {
          'is-active': window.location.pathname == '/chat/history/' + chat.id,
        })}
      >
        <figure className="chat-list-item-avatar">
          <img src={chat.client.avatar} />
        </figure>

        <div className="chat-list-item-main">
          <div className="chat-list-item-main-top">
            <div className="chat-list-item-name">{chat.client.name}</div>
          </div>

          <div className="chat-list-item-message">
            {chat.message && chat.message.content}
          </div>
        </div>
        <div className="chat-list-item-right">
          <div className="chat-list-item-right-date">
            <DateTooltip date={chat.createdAt} />
          </div>
          <div className="chat-list-item-right-users">
            {chat.users.map(user => (
              <Tooltip content={user.name} key={user.id}>
                <figure className="chat-list-item-right-users-item">
                  <img src={user.avatar} />
                </figure>
              </Tooltip>
            ))}
          </div>
        </div>
      </Link>
    </>
  )
}

export default HistoryList
